<template>
  <v-toolbar id="core-toolbar" app style="background: #eee">
    <div class="v-toolbar-title">
      <v-toolbar-title class="tertiary--text font-weight-light">
        <v-btn class="default v-btn--simple" dark icon @click.stop="onClickBtn">
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>
    </div>

    <v-spacer />
    <v-toolbar-items>
      <v-flex align-center layout py-2>
        <v-btn
          dark
          v-if="isEmulation && !responsive"
          color="red"
          @click="stopEmulation"
          >ATTENTION! You are in user emulation mode. Click to CANCEL</v-btn
        >
        <v-btn
          dark
          v-if="isEmulation && responsive"
          color="red"
          @click="stopEmulation"
          >Cancel emulation mode</v-btn
        >

        &nbsp;&nbsp;&nbsp;&nbsp;

        <v-select
          md4
          :error-messages="hasUnread ? 'Please check unread Events' : ''"
          v-model="sponsor"
          :items="sponsors"
          item-text="name"
          item-value="id"
          class="purple-input"
          :disabled="sponsorsDisabled"
          :prepend-icon="hasUnread ? 'mdi-alert' : ''"
        >
          <template slot="item" scope="{ item, index }">
            <v-badge v-if="item.unread" color="red" right>
              {{ item.name }}
              <template slot="badge">
                <span>{{ item.unread }}</span>
              </template>
            </v-badge>

            <span v-if="!item.unread">{{ item.name }}</span>
          </template>
        </v-select>

        <v-checkbox
          label="Show closed protocol"
          v-model="isShowClosedProtocol"
          v-bind:false-value="0"
          v-bind:true-value="1"
          class="custom-checkbox"
        ></v-checkbox>

        <!--router-link v-ripple class="toolbar-items" to="/">
          <v-icon color="tertiary">mdi-view-dashboard</v-icon>
        </router-link-->

        <v-menu
          bottom
          left
          content-class="dropdown-menu"
          offset-y
          transition="slide-y-transition"
        >
          <a v-ripple slot="activator" class="toolbar-items pt-0">
            {{ user }} &nbsp;<v-icon color="tertiary">mdi-account</v-icon>
          </a>

          <v-card>
            <v-list dense>
              <!-- //issue 679 -->
              <v-list-tile @click="changePassword"> Change Password </v-list-tile>
              <!-- //issue 679 -->
              <v-list-tile to="/logout"> Logout </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapMutations } from "vuex";
import { isEmulation, stopEmulation } from "@/utils/auth";

export default {
  data: () => ({
    title: null,
    responsive: false,
    responsiveInput: false,
    on: null,
  }),
  watch: {
    $route(val) {
      this.title = val.name;
    },
    sponsor(v) {
      this.$root.$emit("sponsorChanged", v);
    },
    isShowClosedProtocol(v) {
      this.$root.$emit("showClosedProtocolChanged", v);
    },
  },
  computed: {
    user() {
      return this.$store.getters.name + " (" + this.$store.getters.role + ") ";
    },
    sponsors() {
      return this.$store.getters.sponsors;
    },
    sponsor: {
      get() {
        return this.$store.getters.sponsor_id;
      },
      set(v) {
        this.$store.dispatch("app/setSponsor", v);
      },
    },
    isShowClosedProtocol: {
      get() {
        return this.$store.getters.isShowClosedProtocol;
      },
      set(v) {
        this.$store.dispatch("app/setIsShowClosedProtocol", v);
      },
    },
    sponsorsDisabled() {
      return this.$store.getters.sponsorsDisabled;
    },
    hasUnread() {
      return this.sponsors.filter((el) => el.unread).length != 0;
    },
    isEmulation() {
      return isEmulation();
    },
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },

  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    onClick() {
      //
    },
    //issue 679
    changePassword() {
    //issue 679
      this.$store.dispatch("app/openChangePassword", {
        title: "Change password!",
      });
    },
    stopEmulation() {
      this.$store.dispatch("app/startLoading");
      stopEmulation();
      location.reload();
      // this.$router.replace({ name: 'Dashboard', force: true });
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    },
  },
};
</script>

<style>
#core-toolbar a {
  text-decoration: none;
}
.v-toolbar {
  margin-bottom: 0px !important;
}
.big-checkbox .v-input--selection-controls__input {
  transform: scale(1.5); /* Aumenta la scala del checkbox */
}

.custom-checkbox .v-input--selection-controls__input {
  transform: scale(1.5); /* ingrandisce la checkbox */
  margin-left: 30px;
  background-color: white !important;
}

/* Riquadro della checkbox con interno bianco e bordo scuro */
.custom-checkbox input[type="checkbox"] + .v-icon {
  background-color: white !important;
  border: 2px solid #333 !important; /* bordo scuro (quasi nero) */
  border-radius: 2px;
}

/* Colore della spunta */
.custom-checkbox input[type="checkbox"]:checked + .v-icon {
  color: black !important; /* o altro colore per il checkmark */
}

/* Etichetta visibile e leggibile */
.custom-checkbox label {
  font-size: 16px;
  font-weight: bold;
}

.custom-checkbox {
  padding: 12px;
}
</style>
